import Inputmask from "inputmask"

class DomClass {
    getOffsetSum(el) {
        let top=0, 
        left=0
    
        while(el) {
            top = top + parseFloat(el.offsetTop)
            left = left + parseFloat(el.offsetLeft)
            el = el.offsetParent        
        }
        
        return { top, left }
    }

    setCenter(selector) {
        const el = document.querySelector(selector),
        sTop = window.scrollY + 30,
        sLeft = window.scrollX,
        wH = window.innerHeight,
        wW = document.body.offsetWidth,
        eH = el.offsetHeight,
        eW = el.offsetWidth

        let top = (wH - eH) / 2 + sTop

        if (top < sTop) top = sTop + 50

        el.style.top = `${ top }px`
        el.style.left = `${ ((wW - eW) / 2 + sLeft) }px`
    }

    setMask(input, matrix='+7 (999) 999-99-99') {
        const selector = typeof input === 'string' ? document.getElementById(input) : input

        const im = new Inputmask(matrix)

        im.mask(selector)
    }
}

const Dom = new DomClass()

export default Dom